"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReportComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _nicbaseForms = require("nicbase-forms");

var _nicbaseIcons = require("nicbase-icons");

var _nicbaseTranslation = require("nicbase-translation");

var _yup = require("yup");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ReportComponent = function ReportComponent(_ref) {
  var tour = _ref.tour,
      onUpdateTourProperty = _ref.onUpdateTourProperty;
  var intl = (0, _nicbaseTranslation.useIntl)();

  var _useState = (0, _react.useState)(''),
      _useState2 = _slicedToArray(_useState, 2),
      reportRecipient = _useState2[0],
      setReportRecipient = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      reportRecipientError = _useState4[0],
      setReportRecipientError = _useState4[1];

  var emailSchema = (0, _yup.string)().email();
  var _tour$report = tour.report,
      report = _tour$report === void 0 ? {} : _tour$report;
  var _report$recipients = report.recipients,
      recipients = _report$recipients === void 0 ? [] : _report$recipients,
      _report$showGeoInform = report.showGeoInformation,
      showGeoInformation = _report$showGeoInform === void 0 ? false : _report$showGeoInform,
      _report$shareViaEmail = report.shareViaEmail,
      shareViaEmail = _report$shareViaEmail === void 0 ? true : _report$shareViaEmail,
      _report$uploadAsIdocF = report.uploadAsIdocFormat,
      uploadAsIdocFormat = _report$uploadAsIdocF === void 0 ? false : _report$uploadAsIdocF;

  var onShowGeoInformationChanged = function onShowGeoInformationChanged() {
    onUpdateTourProperty({
      report: _objectSpread(_objectSpread({}, report), {}, {
        showGeoInformation: !showGeoInformation
      })
    });
  };

  var onShareViaEmailChanged = function onShareViaEmailChanged() {
    onUpdateTourProperty({
      report: _objectSpread(_objectSpread({}, report), {}, {
        shareViaEmail: !shareViaEmail
      })
    });
  };

  var onUploadAsIdocFormatChanged = function onUploadAsIdocFormatChanged() {
    onUpdateTourProperty({
      report: _objectSpread(_objectSpread({}, report), {}, {
        uploadAsIdocFormat: !uploadAsIdocFormat
      })
    });
  };

  var onDeleteEmailClicked = function onDeleteEmailClicked(recipient) {
    var updatedReportRecipients = recipients === null || recipients === void 0 ? void 0 : recipients.filter(function (rec) {
      return rec !== recipient;
    });
    onUpdateTourProperty({
      report: _objectSpread(_objectSpread({}, report), {}, {
        recipients: updatedReportRecipients
      })
    });
  };

  var onAddReportRecipientClicked = function onAddReportRecipientClicked() {
    var lowerCaseEmail = reportRecipient.toLowerCase();

    try {
      if (emailSchema.validateSync(lowerCaseEmail)) {
        var updatedReportRecipients = recipients // remove an already existing duplicate
        .filter(function (recipient) {
          return recipient !== lowerCaseEmail;
        }) // add the new object
        .concat(lowerCaseEmail);
        onUpdateTourProperty({
          report: _objectSpread(_objectSpread({}, report), {}, {
            recipients: updatedReportRecipients
          })
        });
        setReportRecipient('');
        setReportRecipientError(false);
      }
    } catch (e) {
      setReportRecipientError(true);
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-128"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-2"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourReportMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.tourReportPositionMessage"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.withoutPositionInformation"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: showGeoInformation,
    onChange: onShowGeoInformationChanged
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.withPositionInformation"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.uploadReport"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: shareViaEmail,
    onChange: onShareViaEmailChanged
  }), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.emailReport"
  }))), !shareViaEmail ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-left items-center mt-2 ml-4"
  }, /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
    id: "widgets.tourBoard.Idoc"
  })), /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Switch, {
    className: "mx-1",
    checked: uploadAsIdocFormat,
    onChange: onUploadAsIdocFormatChanged
  }))) : null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseForms.Input, {
    className: "mr-2 w-72",
    value: reportRecipient,
    label: intl.formatMessage({
      id: 'common.email'
    }),
    error: reportRecipientError && /*#__PURE__*/_react["default"].createElement(_nicbaseTranslation.FormattedMessage, {
      id: "common.emailIsNotValid"
    }),
    onChange: function onChange(newValue) {
      setReportRecipientError(false);
      setReportRecipient(newValue);
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    title: intl.formatMessage({
      id: 'widgets.tourBoard.report.addButton'
    }),
    onClick: onAddReportRecipientClicked
  }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Plus, {
    className: "cursor-pointer h-5 w-5"
  }))), recipients.map(function (recipient) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex items-center mb-2"
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: "w-72 mr-2 truncate"
    }, recipient), /*#__PURE__*/_react["default"].createElement("span", {
      title: intl.formatMessage({
        id: 'widgets.tourBoard.report.deleteButton'
      }),
      onClick: function onClick() {
        return onDeleteEmailClicked(recipient);
      }
    }, /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Delete, {
      className: "fill-primary cursor-pointer h-5 w-5"
    })));
  }));
};

exports.ReportComponent = ReportComponent;

var noop = function noop() {};

ReportComponent.propTypes = {
  tour: _propTypes["default"].shape({
    alarms: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes["default"].number.isRequired,
      type: _propTypes["default"].string
    })),
    wayPoints: _propTypes["default"].instanceOf(Object),
    report: _propTypes["default"].shape({
      recipients: _propTypes["default"].arrayOf(_propTypes["default"].string),
      showGeoInformation: _propTypes["default"].bool,
      shareViaEmail: _propTypes["default"].bool,
      uploadAsIdocFormat: _propTypes["default"].bool
    }),
    smsRecipients: _propTypes["default"].instanceOf(Object),
    etaProvider: _propTypes["default"].string,
    showGeoInformationInReport: _propTypes["default"].bool,
    scheduledStartTime: _propTypes["default"].shape({})
  }).isRequired,
  onUpdateTourProperty: _propTypes["default"].func
};
ReportComponent.defaultProps = {
  onUpdateTourProperty: noop
};
var _default = ReportComponent;
exports["default"] = _default;